import { useEndpointFetch } from '../../global/network/useEndpointFetch';
import { useSnackbar } from '../../global/config/useSnackbar';
import { saveBase64Pdf } from './certificate-download';

export const useDownloadCertificate = () => {
  const { setSnackbar } = useSnackbar();
  const downloadFetch = useEndpointFetch<{ volunteerCertificateId: string }, { fileName: string; pdf: string }>(
    '/vm/certificate/download'
  );

  const download = (volunteerCertificateId: string) =>
    downloadFetch
      .run({ volunteerCertificateId })
      .then((response) => {
        if (!response.ok) throw new Error(response.data?.message);
        const { fileName, pdf } = response.data.data;
        saveBase64Pdf(pdf, fileName);
        return true;
      })
      .catch((e) => {
        setSnackbar({ open: true, variant: 'error', message: e?.message || 'Unable to download certificate' });
        return false;
      });

  return { download, downloading: downloadFetch.isLoading };
};
